/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useAuthorization } from '../../providers/authorization';
export function Unauthorized(props) {
    const { children } = props;
    return children;
}
export function Authorized(props) {
    const { children } = props;
    return children;
}
export function PrivatePropertyContainer(props) {
    const { children = React.createElement(React.Fragment, null), unauthorizedComponent } = props;
    const { authToken } = useAuthorization();
    const getUnauthorizedElement = () => {
        if (unauthorizedComponent) {
            return unauthorizedComponent;
        }
        else {
            const childArray = React.Children.toArray(children);
            const element = childArray.find((x) => x.type.name === Unauthorized.name);
            return element || React.createElement("div", null, "Please log in to view this.");
        }
    };
    const getAuthorizedElement = () => {
        const childArray = React.Children.toArray(children);
        const element = childArray.find((x) => x.type.name === Authorized.name);
        return element || children;
    };
    return (authToken === null || authToken === void 0 ? void 0 : authToken.length) ? getAuthorizedElement() : getUnauthorizedElement();
}
PrivatePropertyContainer.Unauthorized = Unauthorized;
PrivatePropertyContainer.Authorized = Authorized;
//# sourceMappingURL=index.js.map